export const composerPillWidthClass = 'w-full max-w-[704px]';

export const composerFeedPillClass = 'bg-white border-black/10';

export const composerFloatingShadowClass = 'shadow-[0px_0px_0px_0px_rgba(0,0,0,0.02),0px_8px_12px_0px_rgba(0,0,0,0.1)]';

export const composerCommentPillClass =
  'border-black/15 bg-white/60 backdrop-blur-[20px] shadow-[0px_0px_0px_0px_rgba(0,0,0,0.02),0px_8px_24px_0px_rgba(0,0,0,0.1)]';

export const composerTriggerAppearances = {
  feed: composerFeedPillClass,
  comment: composerCommentPillClass,
} as const;
